var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEve = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34.5 33.85",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#009d49;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.54,33.35v-4l2.22-1.63V24.9l1.63-2.21L7,24.9v2.86l1.05.76h.55l1.11-6.66.46-1.49,1.19-1.81,1.19,1.81L13,21.86l.8,4.79H17l.78,2V30.2l1.35-.14a5.33,5.33,0,0,0,.41-3.61c-.3-1.33-.49-.25-1.38-.44a1.06,1.06,0,0,1-.65-.64c-.18-.44.35-.66.7-.82-.75,0-1.82-.66-1.09-1.67a1.05,1.05,0,0,1,1.58-.27c-.17-.36-.19-1.16.41-1.16,1,0,1.42.56,1.21,1.23.67-.23.67-.33,1.11.11.25.25.44.66-.3,1.06.61.1,1.22.57,1,1.19-.33,1.17-1.14.41-1.48.75-.79.79-.54,3.36.23,4.13q1.8-.14,3.6-.15V16.84H29v.91h3.1V30.38c.8.15,1.6.33,2.39.54V0H0V33.85c.51-.18,1-.34,1.54-.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.58,22.84a.51.51,0,0,0-.51.51v.92h1v-.92a.51.51,0,0,0-.5-.51"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEve);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/EVE.e33d91d031000dd6b323e6d5c801a027.svg";